module.exports = __webpack_public_path__ + "static/media/empty.9e6c9267.svg";